<script>
import { resolveTooltipDataItemValue, buildTooltipDataItemChildren } from '../utils';
import { ITEM_CSS_CLASS } from '../constants';

export const ItemRender = {
    render(createElem) {
        const { data, item, cssClass } = this;
        const value = data?.[item.value] ?? null;
        const valueToReplace = resolveTooltipDataItemValue(value, item);
        const children = buildTooltipDataItemChildren(createElem, item, valueToReplace, cssClass);
        return createElem('div', { class: [cssClass] }, children);
    },
    props: {
        item: {
            type: Object
        },
        data: {
          type: Object
        },
        cssClass: {
            type: String,
            default: ITEM_CSS_CLASS
        }
    }
};

export default ItemRender;
</script>
<style scoped lang="pcss" src="./ItemRender.pcss"></style>
